import classes from './CardTab.module.scss';

const CardTab = (props) => {
	return (
		<div
			className={[classes.tab, props.selected ? classes.selected : ''].join(' ')}
			onClick={() => {
				if (props.onClick) {
					props.onClick();
				}
			}}
		>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<span className={[classes.title, props.selected ? classes.whiteColor : classes.greyColor].join(' ')}>
					{props.title}
				</span>
			</div>
		</div>
	);
};

export default CardTab;
